<template>
  <svg :width="size" :height="size" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.449 28.586">
    <g id="Group_31323" data-name="Group 31323" transform="translate(607.866 -11489.8)">
      <g id="Group_31322" data-name="Group 31322" transform="translate(-607.866 11489.8)">
        <rect
          id="Rectangle_8274"
          data-name="Rectangle 8274"
          width="20.228"
          height="3.034"
          rx="1.517"
          transform="translate(16.449 14.282) rotate(135)"
          :fill="color"
        />
        <rect
          id="Rectangle_8275"
          data-name="Rectangle 8275"
          width="20.228"
          height="3.034"
          rx="1.517"
          transform="translate(2.146 0) rotate(45)"
          :fill="color"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#374151'
    },
    size: {
      type: [Number, String],
      default: 24
    }
  }
}
</script>
